export default "__VITE_ASSET__DgT0xhER__"